module.exports = require("codemirror/mode/javascript/javascript");